module.exports = __webpack_public_path__ + "img/fi-rr-stethoscope.ffc57340.svg";